import React from "react";
import { useHistory } from "react-router-dom";

function Dropdown(props) {
  const history = useHistory();

  function clickHandler(id) {
    history.push(`/${id}`);
    window.location.reload();
  }

  return (
    <div className="tab">
      <input
        type="radio"
        id={"rd" + props.season}
        name="rd"
        className="input-tag"
      />
      <label className="tab-label" htmlFor={"rd" + props.season}>
        Season {props.season}
      </label>
      <div className="tab-content">
        {props.episode.map(res => (
          <div>
            {res.vimeo === "Comming Soon" ? (
              <div className="episode-single">Comming Soon</div>
            ) : (
              <div
                className="episode-single"
                onClick={e => clickHandler(res.vimeo)}
                key={res.vimeo}
              >
                Episode {res.episode}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default Dropdown;
